import React from 'react';
import "./about.css"

import about from "../../assets/about.jpg"
import aboutstory from "../../assets/aboutstory.png"
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';  
const About = () => {
  return (

<>

     <Helmet>
          <title>Vasmi Group | Top Digital Marketing Agency in Vizag</title>
        </Helmet>

        <div className='about-main-container'></div>
    
    <div className='about'>
    <div className='about-main'>
    <img src={about} alt='about'/>
    <p className='about-head-main'>About Us</p>
    </div>
    <div className='sde-sec-one about-sec-img'>
        <div className='sde-sec-one-left about-secure'>
            <p className='sde-sec-left-heading about-sec-head'>
            <strong>

            Our Story
            </strong>

            </p>
            <p className='sde-sec-one-para about-secc'>
            Our story at Vasmi Group began with a vision to revolutionize talent acquisition, IT solutions, 
            and marketing strategies in Visakhapatnam. Founded by Mr. Niranjan Nakka, our journey is fueled
             by a commitment to excellence and innovation. With a focus on digital marketing in Vizag and beyond, 
             we strive to stand out as the top choice for businesses seeking advertising agencies in Visakhapatnam. 
             Through strategic SEO services, we elevate brand visibility, while our mobile app development in Vizag 
             ensures cutting-edge technology solutions. As a leading recruitment agency in Visakhapatnam, 
             we connect top-tier talent with thriving businesses. At Vasmi Group, our motto is to be your trusted 
             partner on the journey to excellence.
            </p>

            
        </div>
        <img src={aboutstory} alt='Our Journey and Story at Vasmi Group' className='krishh' loading="lazy" />
      </div>
      <div className='about-sec-one'>
      <div className='about-sec-one-para'> 
      <p className='about-sec-one-story'>
      Our Vision
      </p>
      <p className='about-sec-one-sub-para'>
      At Vasmi Group, our vision is to be the architects of digital success, seamlessly blending innovation,  strategy, and expertise. We aspire to redefine business excellence by offering comprehensive digital  marketing, website development, and recruitment services. Our mission is to empower brands with a  dynamic online presence, crafted through cutting-edge websites and fuelled by strategic digital  marketing campaigns. We envision not just fulfilling but exceeding our client's expectations, creating  an ecosystem where businesses thrive, websites resonate, and teams flourish.
            </p>
      </div>
      <div className='about-sec-one-para'> 
      <p className='about-sec-one-story'>
        Our Mission
      </p>
      <p className='about-sec-one-sub-para'>
      At Vasmi Group, our mission is to catalyze your digital ascendancy through an integrated approach of  unparalleled digital marketing, bespoke website development, and strategic recruitment services.  We are committed to fostering your brand's online resonance, leveraging cutting-edge technologies  and innovative strategies. Our dedicated team strives to empower businesses with impactful digital  solutions, ensuring your digital footprint transcends expectations. Through adept website  development and astute recruitment, we aim to build not just brands, but sustainable ecosystems of  success.

            </p>
      </div>
      </div>
      <div className='about-sec-two'>
      <p className='about-sec-two-head'>
        Our Values
      </p>

      <div className='about-sec-sub-two'>
        <div className='about-sec-sub-two-one'>


        <p className='about-sec-two-head-two'>
        Innovation
        </p>

        <p className='about-sec-two-head-three'>
        Igniting tech excellence, crafting avant-garde marketing, and pioneering recruitment  solutions that redefine industry standards, ensuring clients stay ahead in the digital and IT landscape.

        </p>

        </div>
        <div className='about-sec-sub-two-one'>


        <p className='about-sec-two-head-two'>
        Collaboration
                </p>

        <p className='about-sec-two-head-three'>
        Fostering synergy between tech brilliance and strategic marketing, facilitating  seamless collaboration in our recruitment endeavors, building comprehensive solutions that drive  success for clients.

        </p>

        </div>
        <div className='about-sec-sub-two-one'>


        <p className='about-sec-two-head-two'>
        Integrity
                </p>

        <p className='about-sec-two-head-three'>
        Upholding unwavering ethical standards, ensuring transparent communication, and  delivering trustworthy marketing, IT services, and recruitment processes that cultivate  enduring relationships and client satisfaction.

        </p>

        </div>
        <div className='about-sec-sub-two-one'>


        <p className='about-sec-two-head-two'>
        Adaptability
                </p>

        <p className='about-sec-two-head-three'>
        Embracing the ever-evolving digital and IT landscape, we tailor agile strategies, ensuring  our clients remain adaptable and competitive in dynamic markets, driving sustainable success.

        </p>

        </div>
      </div>
     </div>      
    </div>
    </>
  );
}

export default About;
